"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        button: {
            borderStyle: 'none',
            padding: 0,
            margin: 0,
            backgroundColor: 'transparent',
            width: '100%',
        },
        cell: function (_a) {
            var width = _a.width, minWidth = _a.minWidth;
            return ({
                boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.15)',
                borderRight: "1px solid ".concat(themes_1.materialColors.grey[100]),
                width: width || '100px',
                minWidth: minWidth || '100px',
                padding: '14px 12px',
                '&:first-child': {
                    paddingLeft: '20px',
                },
            });
        },
        checkbox: {
            boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.15)',
            width: '30px',
            padding: '14px 12px',
            '&:first-child': {
                paddingLeft: '20px',
            },
        },
        filter: {
            marginLeft: '8px',
        },
    });
});
